import React from 'react';
import T from 'prop-types';
import cx from 'classnames';

import { stepList } from '../config';

const ProcessTrack = ({ stepsState }) => (
  <div className="process-track-container">
    {stepList.map((step) => (
      <div
        key={step}
        className={cx('process-track-block', {
          [`process-track-block-${stepsState[step]}`]: stepsState[step],
        })}
      >
        <div className="process-track-line" />
        <div className="process-track-ball" />

        <div className="process-track-block-filled">
          <div className="process-track-line" />
          <div className="process-track-ball" />
        </div>
      </div>
    ))}
    <div className="process-track-block">
      <div className="process-track-line" />

      <div className="process-track-block-filled">
        <div className="process-track-line" />
      </div>
    </div>
  </div>
);

ProcessTrack.propTypes = {
  stepsState: T.shape({
    kpi: T.string,
    metric_name: T.string,
    correlation_r: T.string,
    industry_benchmark: T.string,
    report_generation: T.string,
  }),
};

export default ProcessTrack;
